import type React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Page = styled.div`
  text-align: center;
  padding: 48px;
`

const NotFoundPage = (): React.JSX.Element => (
  <Page>
    <h1>404 — Page Not Found</h1>
    <Link to="/dashboard">Go to Dashboard</Link>
  </Page>
)

export default NotFoundPage
